import { Provider } from 'react-redux';

import { store } from './state/store';
import Router from './routes/Router';
import AuthWrapper from './components/AuthWrapper';

export default function App() {
    return (
        <Provider store={store}>
            <AuthWrapper>
                <Router />
            </AuthWrapper>
        </Provider>
    );
}
